
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

// icons
const icons = {
  ArrowForwardIosIcon,
  QrCode2Icon,
  BusinessCenterIcon
};

// ==============================|| MENU ITEMS - UTILITIES ||============================== //

const customer = {
  id: 'customer',
  title: 'Digital Makrting Platform',
  type: 'group',
  role:'MLM_CUSTOMER',
  children: [
    {
      id: 'aboutus',
      title: 'About Us',
      type: 'item',
      url: '/aboutus',
      icon: icons.QrCode2Icon
  },
  {
      id: 'contactus',
      title: 'Contact Us',
      type: 'item',
      url: '/contactus',
      icon: icons.QrCode2Icon
  },
    {
        id: 'tandcpage',
        title: 'Terms and Conditions',
        type: 'item',
        url: '/tandcpage',
        icon: icons.QrCode2Icon
    },
    {
        id: 'shippingpolicy',
        title: 'Shipping Policy',
        type: 'item',
        url: '/shippingpolicy',
        icon: icons.QrCode2Icon
    },
    {
        id: 'privacypolicy',
        title: 'Privacy Policy',
        type: 'item',
        url: '/privacypolicy',
        icon: icons.QrCode2Icon
    },
    {
        id: 'userdatadeletion',
        title: 'User Data Deletion',
        type: 'item',
        url: '/userdatadeletion',
        icon: icons.QrCode2Icon
    },
    {
        id: 'cancellation',
        title: 'Cancellation & Return',
        type: 'item',
        url: '/cancellation',
        icon: icons.QrCode2Icon
    }
  
  
  

  
  
  //     {
  //     id: 'orders',
  //     title: 'My Orders',
  //     type: 'item',
  //     url: '/',
  //     bottomMenu:'ORDERS',
  //     icon: icons.QrCode2Icon
  // },{
  //     id: 'shopping',
  //     title: 'Buy Products',
  //     type: 'item',
  //     url: '/',
  //     bottomMenu:'HOME',
  //     icon: icons.QrCode2Icon
  // },{
  //     id: 'cart',
  //     title: 'Cart',
  //     type: 'item',
  //     url: '/',
  //     bottomMenu:'CART',
  //     icon: icons.QrCode2Icon
  // }
  
  
  ]
};

export default customer;
